// Keep the announcement node outside the replaced server-rendered content.
document.querySelectorAll('[data-catalog]').forEach(root=>{
 const status=root.querySelector('[data-catalog-status]'); let request,sequence=0;
 // Some desktop browsers report a touch primary pointer even while a mouse is in use.
 // Actual mouse pointer events enable the image overlay without enabling it for taps.
 const cardSelector='.commerce-folio__card,.ritual-shop__item';
 root.addEventListener('pointerover',event=>{
  if(event.pointerType!=='mouse'||window.innerWidth<769)return;
  const card=event.target.closest(cardSelector);
  if(!card||!root.contains(card))return;
  root.classList.add('catalog-mouse-ready');
  requestAnimationFrame(()=>{if(card.isConnected&&root.classList.contains('catalog-mouse-ready'))card.classList.add('is-mouse-hover');});
 });
 root.addEventListener('pointerout',event=>{
  if(event.pointerType!=='mouse')return;
  const card=event.target.closest(cardSelector);
  if(card&&!card.contains(event.relatedTarget))card.classList.remove('is-mouse-hover');
 });
 root.addEventListener('pointerdown',event=>{
  if(event.pointerType==='mouse')return;
  root.classList.remove('catalog-mouse-ready');
  root.querySelectorAll('.is-mouse-hover').forEach(card=>card.classList.remove('is-mouse-hover'));
 });
 async function update(url,{history=true}={}){
  request?.abort();request=new AbortController();const ticket=++sequence;
  const focus=document.activeElement;const key=focus?.id;const name=focus?.name;const value=focus?.value;
  const top=window.scrollY;root.setAttribute('aria-busy','true');status.textContent=root.dataset.loading;
  try{
   const fetchURL=new URL(url);fetchURL.searchParams.set('section_id',root.dataset.section);
   const response=await fetch(fetchURL,{signal:request.signal,headers:{Accept:'text/html'}});
   if(!response.ok)throw new Error('Catalog unavailable');
   const html=new DOMParser().parseFromString(await response.text(),'text/html');
   const content=html.querySelector('[data-catalog-content]');if(!content)throw new Error('Missing catalog');
   if(ticket!==sequence)return;
   root.querySelector('[data-catalog-content]').replaceWith(content);
   if(history)window.history.pushState({},'',url);
   const target=(key&&root.querySelector('#'+CSS.escape(key)))||[...root.querySelectorAll('input,select,button')].find(el=>name&&el.name===name&&el.value===value);
   if(target)target.focus({preventScroll:true});window.scrollTo({top,behavior:'instant'});
   const count=content.querySelector('[data-catalog-count]')?.dataset.catalogCount||'0';status.textContent=root.dataset.updated.replace('__COUNT__',count);
  }catch(error){if(error.name!=='AbortError'&&ticket===sequence)status.textContent=root.dataset.error;}
  finally{if(ticket===sequence)root.removeAttribute('aria-busy');}
 }
 root.addEventListener('submit',event=>{if(!event.target.matches('[data-catalog-form]'))return;event.preventDefault();const url=new URL(event.target.action);const params=new URLSearchParams(new FormData(event.target));for(const [k,v] of [...params])if(!v)params.delete(k);url.search=params.toString();update(url);});
 root.addEventListener('change',event=>{if(event.target.matches('select[name=sort_by],input[type=checkbox]'))event.target.closest('[data-catalog-form]')?.requestSubmit();});
 root.addEventListener('click',event=>{const link=event.target.closest('[data-catalog-clear],.commerce-folio__pagination a,.ritual-shop__pagination a');if(!link||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;event.preventDefault();update(new URL(link.href));});
 window.addEventListener('popstate',()=>update(new URL(location.href),{history:false}));
});
